import { LANG } from './lang';

export const OUR_SERVICES = [
  {
    title: {
      [LANG.EN]: 'Halachic Estate Protection',
      [LANG.HE]: 'צוואה כהלכה',
    },
    description: {
      [LANG.EN]: 'Secure your legacy with proper halachic estate planning',
      [LANG.HE]: 'הבטחת הירושה בהתאם להלכה',
    },
    btnText: {
      [LANG.EN]: 'Learn More',
      [LANG.HE]: 'למידע נוסף',
    },
    color: 'info',
    icon: 'file-contract',
    link: 'https://wills.businesshalacha.com',
    isDirectLink: true,
  },
  {
    title: {
      [LANG.EN]: "Bais Hora'ah",
      [LANG.HE]: 'בית הוראה',
    },
    description: {
      [LANG.EN]: 'Cost-effective mediation services & arbitration',
      [LANG.HE]: 'ישוב סכסוכים ובוררויות במחירים נוחים',
    },
    btnText: {
      [LANG.EN]: 'Reach out',
      [LANG.HE]: 'צור קשר',
    },
    color: 'success',
    icon: 'synagogue',
    link: '/contact',
  },
  {
    title: {
      [LANG.EN]: 'Business Services',
      [LANG.HE]: 'שירותי המכון',
    },
    description: {
      [LANG.EN]: 'Personalized guidance & rapid dispute resolution',
      [LANG.HE]: 'הדרכה אישית לפתרון סכסוכים',
    },
    btnText: {
      [LANG.EN]: 'Schedule a call',
      [LANG.HE]: 'לקביעת שיחה',
    },
    color: 'warning',
    icon: 'handshake-alt',
    link: '/contact',
  },
  {
    title: {
      [LANG.EN]: 'Ribbis Awareness',
      [LANG.HE]: 'ריבית ועיסקא',
    },
    description: {
      [LANG.EN]: 'Navigate financial transactions with Ribbis compliance',
      [LANG.HE]: 'ניהול עסקאות פיננסיות בהתאם להלכות ריבית',
    },
    btnText: {
      [LANG.EN]: 'Visit Site',
      [LANG.HE]: 'בקר באתר',
    },
    color: 'default',
    icon: 'percentage',
    link: 'https://ribbis.businesshalacha.com',
    isDirectLink: true,
  },
];
